import script from "./grvReport.vue?vue&type=script&setup=true&lang=js"
export * from "./grvReport.vue?vue&type=script&setup=true&lang=js"

import "./grvReport.vue?vue&type=style&index=0&id=2f3a87b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3a87b1"]])

export default __exports__